<script setup lang="ts">
import { useDefaultStore } from "@/store";

const store = useDefaultStore();
</script>

<template lang="pug">
footer.footer-bar-wrapper
	.footer-bar-top
		.footer-bar-top-left
			span.label {{ $t("app.companyInfo.nameLabel") }}:&nbsp;
			span {{ $t("app.companyInfo.name") }}
			br
			span.label {{ $t("app.companyInfo.pibLabel") }}:&nbsp;
			span {{ $t("app.companyInfo.pib") }}
			br
			span.label {{ $t("app.companyInfo.mbLabel") }}:&nbsp;
			span {{ $t("app.companyInfo.mb") }}
			br
			span.label {{ $t("app.companyInfo.addressLabel") }}:&nbsp;
			span
				a(
					href="https://maps.app.goo.gl/gRdpsNX7pvt1TLbG8",
					rel="nofollow",
					aria-label="View location on map",
					target="_blank"
				) {{ $t("app.companyInfo.address") }}
			br
			span.label {{ $t("app.companyInfo.activityLabel") }}:&nbsp;
			span {{ $t("app.companyInfo.activity") }}
			br
			span.label {{ $t("app.companyInfo.emailLabel") }}:&nbsp;
			span
				a(href="mailto:office@suncica.co.rs") office@suncica.co.rs
			br
			span.label {{ $t("app.companyInfo.contactPhoneLabel") }}:&nbsp;
			span
				a(href="tel:+38163267266", @click="store.trackClickCall()") 063/267-266
			br
			span.label {{ $t("app.companyInfo.workingHoursLabel") }}:&nbsp;
			span {{ $t("app.companyInfo.workingHours") }}
		.footer-bar-top-center
			a.footer-bar-top-center-item(
				href="https://www.facebook.com/suncicasolarshop/",
				rel="me nofollow",
				target="_blank",
				aria-label="Find us on social media"
			)
				img(
					src="@/assets/image/socials/socials-fb.svg",
					alt="facebook",
					loading="lazy"
				)
			a.footer-bar-top-center-item(
				href="https://www.tiktok.com/@solarsrbija",
				rel="me nofollow",
				target="_blank",
				aria-label="Find us on social media"
			)
				img(
					src="@/assets/image/socials/socials-tt.svg",
					alt="tiktok",
					loading="lazy"
				)
			a.footer-bar-top-center-item(
				href="https://www.linkedin.com/company/suncica-solarni-paneli-i-solarni-sistemi/",
				rel="me nofollow",
				target="_blank",
				aria-label="Find us on social media"
			)
				img(
					src="@/assets/image/socials/socials-linkedin.svg",
					alt="linkedin",
					loading="lazy"
				)
			a.footer-bar-top-center-item(
				href="https://www.instagram.com/suncica_shop/",
				rel="me nofollow",
				target="_blank",
				aria-label="Find us on social media"
			)
				img(
					src="@/assets/image/socials/socials-instagram.svg",
					alt="instagram",
					loading="lazy"
				)
		.footer-bar-top-right
			.footer-bar-top-right-top
				router-link.footer-bar-top-right-top-left(
					to="/o-nama",
					aria-label="About us"
				) {{ $t("app.about.title") }}
				router-link.footer-bar-top-right-top-right(
					:to="{ name: 'ComplaintsPage' }",
					aria-label="Complaints"
				) {{ $t("app.footer.links.complaints") }}
			.footer-bar-top-right-center
				router-link.footer-bar-top-right-center-left(
					:to="{ name: 'PrivacyPolicyPage' }",
					aria-label="Privacy policy"
				) {{ $t("app.footer.links.privacyPolicy") }}
				router-link.footer-bar-top-right-center-right(
					:to="{ name: 'ContactPage' }",
					aria-label="Contact"
				) {{ $t("app.contact.title") }}
			.footer-bar-top-right-bottom
				router-link.footer-bar-top-right-bottom-left(
					:to="{ name: 'TermsOfUsePage' }",
					aria-label="Terms of use"
				) {{ $t("app.footer.links.termsOfUse") }}
				.footer-bar-top-right-bottom-right
		.footer-bar-top-right-sm
			.footer-bar-top-right-top
				router-link.footer-bar-top-right-top-left(
					to="/o-nama",
					aria-label="About us"
				) {{ $t("app.about.title") }}
				router-link.footer-bar-top-right-center-left(
					:to="{ name: 'PrivacyPolicyPage' }",
					aria-label="Privacy policy"
				) {{ $t("app.footer.links.privacyPolicy") }}
			.footer-bar-top-right-center
				router-link.footer-bar-top-right-bottom-left(
					:to="{ name: 'TermsOfUsePage' }",
					aria-label="Terms of use"
				) {{ $t("app.footer.links.termsOfUse") }}
				router-link.footer-bar-top-right-top-right(
					:to="{ name: 'ComplaintsPage' }",
					aria-label="Complaints"
				) {{ $t("app.footer.links.complaints") }}
			.footer-bar-top-right-bottom
				router-link.footer-bar-top-right-center-right(
					:to="{ name: 'ContactPage' }",
					aria-label="Contact"
				) {{ $t("app.contact.title") }}
	.socials-wrapper-1024
		a.footer-bar-top-center-item(
			href="https://www.facebook.com/suncicasolarshop/",
			rel="me nofollow",
			target="_blank",
			aria-label="Find us on social media"
		)
			img(
				src="@/assets/image/socials/socials-fb.svg",
				alt="facebook",
				loading="lazy"
			)
		a.footer-bar-top-center-item(
			href="https://www.tiktok.com/@solarsrbija",
			rel="me nofollow",
			target="_blank",
			aria-label="Find us on social media"
		)
			img(
				src="@/assets/image/socials/socials-tt.svg",
				alt="tiktok",
				loading="lazy"
			)
		a.footer-bar-top-center-item(
			href="https://www.linkedin.com/company/suncica-solarni-paneli-i-solarni-sistemi/",
			rel="me nofollow",
			target="_blank",
			aria-label="Find us on social media"
		)
			img(
				src="@/assets/image/socials/socials-linkedin.svg",
				alt="linkedin",
				loading="lazy"
			)
		a.footer-bar-top-center-item(
			href="https://www.instagram.com/suncica_shop/",
			rel="me nofollow",
			target="_blank",
			aria-label="Find us on social media"
		)
			img(
				src="@/assets/image/socials/socials-instagram.svg",
				alt="instagram",
				loading="lazy"
			)
	.footer-bar-bottom
		.footer-bar-bottom-center ©2024. Sva prava suncica.co.rs
</template>

<style lang="scss" scoped>
.footer-bar-wrapper {
	padding: 24px 34px 24px 24px;
	background-color: $app-dark-color;

	.socials-wrapper-1024 {
		display: none;
	}

	.footer-bar-top {
		border-bottom: 1px solid #ffffff20;
		.footer-bar-top-left {
			margin-bottom: 30px;
			span {
				font-family: "Galano Grotesque Alt", sans-serif;
				font-size: 16px;
				font-weight: 200;
				line-height: 24px;
				color: $text-color-lighter;
				user-select: all;

				&.label {
					font-weight: 600;
				}

				a {
					font-family: "Galano Grotesque Alt", sans-serif;
					font-size: 16px;
					font-weight: 200;
					line-height: 24px;
					color: $text-color-lighter;
					user-select: all;
					text-decoration: none;

					&:hover {
						opacity: 0.8;
					}
				}
			}
		}
		.footer-bar-top-center {
			color: $text-color-lighter;
			margin-bottom: 30px;
			display: flex;
			justify-content: center;
			align-items: center;

			.footer-bar-top-center-item {
				border-radius: 50%;
				border: 1px solid rgba(255, 255, 255, 0);
				height: 81px;
				width: 81px;
				display: flex;
				align-items: center;
				justify-content: center;
				cursor: pointer;
				margin: 18px;
			}
		}

		.footer-bar-top-right,
		.footer-bar-top-right-sm {
			display: flex;
			flex-direction: column;
			margin-bottom: 24px;

			.footer-bar-top-right-top,
			.footer-bar-top-right-center,
			.footer-bar-top-right-bottom {
				display: flex;
				flex-wrap: wrap;
				flex-direction: column;

				.footer-bar-top-right-top-left,
				.footer-bar-top-right-top-right,
				.footer-bar-top-right-bottom-left,
				.footer-bar-top-right-bottom-right,
				.footer-bar-top-right-center-left,
				.footer-bar-top-right-center-right {
					font-family: "Galano Grotesque Alt", sans-serif;
					text-decoration: none;
					white-space: nowrap;
					color: $text-color-lighter;
					box-sizing: border-box;
					min-width: 50%;
					font-size: 16px;
					font-weight: 600;
					line-height: 20px;
					cursor: pointer;
					margin-bottom: 24px;
				}
			}
		}
		.footer-bar-top-right {
			display: none;
		}
	}

	.footer-bar-bottom {
		display: flex;
		flex-direction: column;
		align-items: center;
		margin: 24px 24px 0;

		.footer-bar-bottom-left,
		.footer-bar-bottom-center,
		.footer-bar-bottom-right {
			color: $text-color-lighter;
			color: $text-color-gray;
			font-family: "Galano Grotesque Alt", sans-serif;
			line-height: 25px;
			display: flex;
			flex-wrap: wrap;
			justify-content: center;
			a {
				text-decoration: none;
				font-family: "Galano Grotesque Alt", sans-serif;
				color: $text-color-gray;
			}
		}
	}
}

@media screen and (width >= 500px) {
	.footer-bar-top-center-item {
		border: 1px solid #ffffff20 !important;

		&:hover {
			border: 1px solid #fff !important;
		}
	}
}

@media screen and (width >= 760px) {
	.footer-bar-wrapper {
		.footer-bar-top {
			justify-content: space-between;
			.footer-bar-top-left {
				span {
					font-size: 18px;
					line-height: 28px;

					a {
						font-size: 18px;
						line-height: 28px;
					}
				}
			}

			.footer-bar-top-right,
			.footer-bar-top-right-sm {
				.footer-bar-top-right-top,
				.footer-bar-top-right-center,
				.footer-bar-top-right-bottom {
					.footer-bar-top-right-top-left,
					.footer-bar-top-right-top-right,
					.footer-bar-top-right-bottom-left,
					.footer-bar-top-right-bottom-right,
					.footer-bar-top-right-center-left,
					.footer-bar-top-right-center-right {
						font-size: 18px;
						line-height: 22px;
					}
				}
			}
		}

		.footer-bar-bottom {
			flex-direction: row;
			justify-content: center;
			.footer-bar-bottom-left,
			.footer-bar-bottom-center,
			.footer-bar-bottom-right {
				font-size: 14px;
				font-weight: 300;
				line-height: 30px;

				a {
					font-size: 14px;
					font-weight: 300;
					line-height: 18.9px;
					display: flex;
					align-items: center;
				}
			}
		}
	}
}

@media screen and (width >= 1024px) {
	.footer-bar-wrapper {
		padding: 24px 85px;
		.footer-bar-top {
			display: flex;
			flex-direction: row;
			border: none;
			.footer-bar-top-left {
				width: 49%;
				padding-right: 2%;
				span {
					font-size: 20px;
					line-height: 25px;

					a {
						font-size: 20px;
						line-height: 25px;
					}
				}
			}
			.footer-bar-top-center {
				display: none;
			}

			.footer-bar-top-right,
			.footer-bar-top-right-sm {
				width: 34%;
				display: flex;
				flex-direction: column;
				margin-bottom: 24px;

				.footer-bar-top-right-top,
				.footer-bar-top-right-center,
				.footer-bar-top-right-bottom {
					flex-direction: column;
					.footer-bar-top-right-top-left,
					.footer-bar-top-right-top-right,
					.footer-bar-top-right-bottom-left,
					.footer-bar-top-right-bottom-right,
					.footer-bar-top-right-center-left,
					.footer-bar-top-right-center-right {
						font-size: 20px;
						line-height: 25px;
					}
				}
			}

			.footer-bar-top-right {
				display: none;
			}
		}

		.socials-wrapper-1024 {
			color: $text-color-lighter;
			margin-bottom: 30px;
			display: flex;
			justify-content: center;
			align-items: center;
			border-bottom: 1px solid #ffffff20;

			.footer-bar-top-center-item {
				border-radius: 50%;
				border: 1px solid rgba(255, 255, 255, 0);
				height: 81px;
				width: 81px;
				display: flex;
				align-items: center;
				justify-content: center;
				cursor: pointer;
				margin: 18px;
			}
		}

		.footer-bar-bottom {
			margin: 24px 24px 0;

			.footer-bar-bottom-left,
			.footer-bar-bottom-center,
			.footer-bar-bottom-right {
				color: $text-color-lighter;
				color: $text-color-gray;
				line-height: 25px;
				a {
					text-decoration: none;
					color: $text-color-gray;
				}
			}

			.footer-bar-bottom-left,
			.footer-bar-bottom-center {
				margin-right: 50px;
			}
		}
	}
}

@media screen and (width >= 1572px) {
	.footer-bar-wrapper {
		.socials-wrapper-1024 {
			display: none;
		}

		.footer-bar-top {
			border-bottom: 1px solid #ffffff20;
			justify-content: space-between;
			.footer-bar-top-left {
				width: 35%;
			}
			.footer-bar-top-center {
				display: flex;
				width: 35%;
			}

			.footer-bar-top-right {
				width: 30%;
				justify-content: center;
				display: flex;

				.footer-bar-top-right-top,
				.footer-bar-top-right-center,
				.footer-bar-top-right-bottom {
					flex-direction: row;
				}

				.footer-bar-top-right-top,
				.footer-bar-top-right-center {
					margin-bottom: 0;
				}
			}

			.footer-bar-top-right-sm {
				display: none;
			}
		}

		.footer-bar-bottom {
			.footer-bar-bottom-left,
			.footer-bar-bottom-center,
			.footer-bar-bottom-right {
				color: $text-color-lighter;
				color: $text-color-gray;
				font-family: "Galano Grotesque Alt", sans-serif;
				line-height: 25px;
				a {
					text-decoration: none;
					font-family: "Galano Grotesque Alt", sans-serif;
					color: $text-color-gray;
				}
			}
		}
	}
}
</style>
